<div class="container-xxl">










    <div>
        <h2>Creazione form</h2>



        <button mat-raised-button (click)="openDialog()">Nuovo elemento</button>

        <!--<div>
      <label for="elementType">Element Type:</label>
      <select [(ngModel)]="selectedElementType" id="elementType">
        <option value="input">Input</option>
        <option value="textarea">Textarea</option>
        <option value="checkbox">Checkbox</option>
        <option value="select">Select</option>
        <option value="header">Header</option>
        <option value="section">Section</option>
      </select>

      <label for="label">Label:</label>
      <input id="label" [(ngModel)]="labelText" placeholder="Enter label text" />

      <label for="insertIndex">Insert at Index:</label>
      <input id="insertIndex" type="number" [(ngModel)]="insertIndex" min="0" placeholder="(Optional)" />

      <button (click)="addElement()">Add Element</button>
    </div>-->

        <form [formGroup]="form">

            <app-form-elements [elements]="formElements" [parentForm]="form.get('elements')"></app-form-elements>

            <!--<div *ngFor="let field of formElements; let i = index">
                <ng-container [ngSwitch]="field.type">
                    <h3 *ngSwitchCase="'header'">{{ field.label }}</h3>
                    <div *ngSwitchCase="'section'" class="section">
                        <h4>{{ field.label }}</h4>
                        <div *ngFor="let child of field.children">
                            <ng-container [ngSwitch]="child.type">
                                <label *ngSwitchCase="'input'">{{ child.label }}<input
                                        [formControlName]="child.name || ''" /></label>
                                <label *ngSwitchCase="'textarea'">{{ child.label }}<textarea
                                        [formControlName]="child.name || ''"></textarea></label>
                                <label *ngSwitchCase="'checkbox'">{{ child.label }}<input type="checkbox"
                                        [formControlName]="child.name || ''" /></label>
                                <label *ngSwitchCase="'select'">{{ child.label }}<select
                                        [formControlName]="child.name || ''">
                                        <option *ngFor="let opt of child.options" [value]="opt">{{ opt }}</option>
                                    </select></label>
                            </ng-container>
                        </div>
                    </div>
                    <div *ngSwitchCase="'subSection'" class="sub-section">
                        <h5>{{ field.label }}</h5>
                        <div *ngFor="let child of field.children">
                            <ng-container [ngSwitch]="child.type">
                                <label *ngSwitchCase="'input'">{{ child.label }}<input
                                        [formControlName]="child.name || ''" /></label>
                                <label *ngSwitchCase="'textarea'">{{ child.label }}<textarea
                                        [formControlName]="child.name || ''"></textarea></label>
                                <label *ngSwitchCase="'checkbox'">{{ child.label }}<input type="checkbox"
                                        [formControlName]="child.name || ''" /></label>
                                <label *ngSwitchCase="'select'">{{ child.label }}<select
                                        [formControlName]="child.name || ''">
                                        <option *ngFor="let opt of child.options" [value]="opt">{{ opt }}</option>
                                    </select></label>
                            </ng-container>
                        </div>
                    </div>
                    <div *ngSwitchDefault>
                        <label>{{ field.label }}</label>
                        <ng-container [ngSwitch]="field.type">
                            <input *ngSwitchCase="'input'" [formControlName]="field.name || ''" />
                            <textarea *ngSwitchCase="'textarea'" [formControlName]="field.name || ''"></textarea>
                            <input *ngSwitchCase="'checkbox'" type="checkbox" [formControlName]="field.name || ''" />
                            <select *ngSwitchCase="'select'" [formControlName]="field.name || ''">
                                <option *ngFor="let opt of field.options" [value]="opt">{{ opt }}</option>
                            </select>
                        </ng-container>
                    </div>
                </ng-container>
            </div>-->
        </form>

        <pre>{{ form.value | json }}</pre>

    </div>

</div>











<mat-button-toggle-group name="fontStyle" aria-label="Font Style">
    <mat-button-toggle value="bold" (click)="cambiaPos(0,-1)">Su</mat-button-toggle>
    <mat-button-toggle value="italic" (click)="cambiaPos(0,+1)">Giù</mat-button-toggle>
    <mat-button-toggle value="underline" (click)="cambiaPos(0,-1)">Elimina</mat-button-toggle>
</mat-button-toggle-group>

<button mat-button (click)="stampa()">Stampa</button>